import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08ff8293"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submission widthRole" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "论文投稿", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "maincc" }, [
  /*#__PURE__*/_createElementVNode("table", {
    border: "1",
    cellspacing: "0"
  }, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "重要时间节点")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "投稿开始时间："),
      /*#__PURE__*/_createElementVNode("td", null, "2023年2月15日")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "征稿截止时间："),
      /*#__PURE__*/_createElementVNode("td", null, "2023年5月1日")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "录用通知日期："),
      /*#__PURE__*/_createElementVNode("td", null, "2023年6月1日")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "论文终稿日期："),
      /*#__PURE__*/_createElementVNode("td", null, "2023年6月15日")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h2", { class: "redTxt" }, [
    /*#__PURE__*/_createTextVNode(" 投稿地址：“"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://review.cacpaper.com/#/913/login",
      target: "_blank"
    }, "点击开始投稿"),
    /*#__PURE__*/_createTextVNode("”，或复制投稿地址在浏览器中打开，投稿地址：http://review.cacpaper.com/#/913/login ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "模版下载"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 英文论文模板请参考IEEE网站要求论文模板："),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.ieee.org/conferences/publishing/templates.html",
        target: "_blank"
      }, "https://www.ieee.org/conferences/publishing/templates.html")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 中文论文模板："),
      /*#__PURE__*/_createElementVNode("a", {
        download: "中文论文模板：",
        href: "https://caa-upload.cacpaper.com/nivdf2023/%E4%B8%AD%E6%96%87%E6%8A%95%E7%A8%BF%E6%A8%A1%E6%9D%BF.doc",
        target: "_blank"
      }, "下载")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 长摘要模板："),
      /*#__PURE__*/_createElementVNode("a", {
        download: "中文论文模板：",
        href: "https://caa-upload.cacpaper.com/nivdf2023/%E9%95%BF%E6%91%98%E8%A6%81%E6%A8%A1%E6%9D%BF.doc",
        target: "_blank"
      }, "下载")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, "征文通知"),
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100%"},
    src: "https://caa-upload.cacpaper.com/nivdf2023/tz.jpeg",
    alt: ""
  })
], -1))

import leftMenu from '@/components/LeftMenu.vue';
import shortNav from '@/components/shortNav.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'submission',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(leftMenu),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(shortNav, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ])
  ]))
}
}

})